import 'css-chunksrc/client/pages/planzoneMembersPage/groupsList/resourceSelect/styles.scss';export default {
  "icon": "_icon_155vp_1",
  "list": "_list_155vp_7"
};